import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../helper/Breadcrumb";
import StatCard from "../Dashboard/StateCard";
import AbandonedCartTable from "./AbandonedCartTable";
import StatusBadge from "../../Components/StatusBadge";
import dateformate from "../../helper/DateFormate";
import Loader from "../../Components/Loader";
import WishlistTable from "./WishlistTable";

const CustomerDetail = () => {
 const { id } = useParams();
 const [detail, setDetail] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
  if (id) getData(id);
 }, [id]);

 const getData = async (id) => {
  setLoading(true);
  try {
   const response = await axiosInstance.get(`users-detail/${id}`);
   if (response.status === 200) {
    const { data } = response.data;
    setDetail(data);
   }
  } catch (error) {
   const err = error.response?.data?.message;
   toast.error(err);
  } finally {
   setLoading(false);
  }
 };

 const breadcrumbdata = [
  { label: "Home", path: "/" },
  { label: "Customer", path: "/customers" },
  { label: "Detail", path: "/customers-detail" },
 ];
 if (loading) {
  return (
 <Loader/>
  );
 }

 if (!detail) {
  return (
   <div className="text-center mt-5">
    <h4>No customer data found</h4>
   </div>
  );
 }

 return (
  <>
   <div className="content-wrapper">
    <div className="page-header mt-5 d-flex justify-content-between align-items-center">
     <h3 className="custom-page-title">Customer Details</h3>
     <Breadcrumb items={breadcrumbdata} />
    </div>

    <div className="row mt-4">
     <div className="col-lg-4 col-md-6 mb-3">
      <StatCard
       label="Total Orders"
       value={detail?._count?.orders || 0}
       color="#3b82f6"
      />
     </div>

     <div className="col-lg-4 col-md-6 mb-3">
      <StatCard
       label="Cancel Orders"
       value={detail?.cancelOrder || 0}
       color="#f97316"
      />
     </div>

     <div className="col-lg-4 col-md-6 mb-3">
      <StatCard
       label="Pending Orders"
       value={detail?.pendingOrder || 0}
       color="#facc15"
      />
     </div>

     <div className="col-12 mb-3">
      <div className="card shadow-sm border-0">
       <div className="card-header bg-white fw-bold d-flex justify-content-between align-items-center">
        <span>Basic Information</span>

<StatusBadge status={detail?.isActive ? "Active" : "Inactive"}/>
       </div>

       <div className="card-body">
        <div className="row" style={{ gap: 0 }}>
         <div className="col-md-3 mb-3">
          <small className="text-dark">Name</small>
          <p className="fw-semibold mb-0">{detail?.name}</p>
         </div>

         <div className="col-md-3 mb-3">
          <small className="text-dark">Email</small>
          <p className="mb-0">{detail?.email}</p>
         </div>

         <div className="col-md-3 mb-3">
          <small className="text-dark">Mobile</small>
          <p className="mb-0">{detail?.mobile_number}</p>
         </div>


         <div className="col-md-3 mb-3">
          <small className="text-dark">Joined On</small>
          <p className="mb-0">{dateformate(detail?.createdAt)}</p>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>

   <div >
 <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap" style={{background:"#fff",padding:"20px" ,color:"#8C0910",}}>
      <h5 className="fw-bold mb-0" >
      <i className="fa-solid fa-address-book mr-2"></i>
      Customer Addresses
    </h5>

    <StatusBadge status="ITEMS" count={detail?.CustomerAddress?.length || 0} />
  </div>

  <div className="row">
    {detail?.CustomerAddress?.length > 0 ? (
      detail.CustomerAddress.map((addr, index) => (
        <div key={addr.id} className="col-lg-6 col-md-6 col-12 mb-4">
          
          <div
            className="p-4 h-100 position-relative"
            style={{
              borderRadius: "12px",
              background: "#fff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
              borderLeft: "4px solid #3b82f6",
              transition: "all 0.2s ease",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="fw-semibold mb-0">
                <i className="fa-solid fa-location-dot text-danger me-2"></i>
                Address {index + 1}
              </h6>

              {addr.GstNumber && (
                <span className="badge bg-warning text-dark">GST</span>
              )}
            </div>

            {/* Address */}
            <p className="mb-1 fw-medium">{addr.address1}</p>

            {addr.address2 && (
              <p className="mb-1 text-muted small">{addr.address2}</p>
            )}

            <p className="mb-2 text-muted small">
              {addr.city}, {addr.state}, {addr.country} - {addr.zipCode}
            </p>

            <hr className="my-2" />

            {/* Contact */}
            <div className="small">
              <p className="mb-1">
                <i className="fa-solid fa-phone me-2 text-primary"></i>
                {addr.mobile}
              </p>

              <p className="mb-1">
                <i className="fa-solid fa-envelope me-2 text-secondary"></i>
                {addr.email}
              </p>

              {addr.whatsapp && (
                <p className="mb-0">
                  <i className="fa-brands fa-whatsapp me-2 text-success"></i>
                  {addr.whatsapp}
                </p>
              )}
            </div>
          </div>

        </div>
      ))
    ) : (
      <div className="col-12 text-center text-muted">
        No address available
      </div>
    )}
  </div>
</div>



  <div className="col-md-12 grid-margin stretch-card flex-column p-0">
  <div className="d-flex justify-content-between align-items-center mb-1 flex-wrap" style={{background:"#fff",padding:"20px" ,color:"#8C0910",}}>
  <h5
    className="fw-bold mb-0" 
  >
    <i className="fa-solid fa-cart-shopping mr-2"></i>
    Abandoned Carts
  </h5>
  <StatusBadge status="ITEMS" count={detail?.abandonedCarts?.length || 0} />
</div>
  <div className="card border-0" >
<AbandonedCartTable detail={detail} />   
  </div>
</div>



<div className="col-md-12 grid-margin stretch-card flex-column p-0">
  <div className="d-flex justify-content-between align-items-center mb-1 flex-wrap" style={{background:"#fff",padding:"20px" ,color:"#8C0910",}}>
  <h5
    className="fw-bold mb-0" 
  >
  <i className="fa-solid fa-heart text-red-500 mr-2"></i>
    Wishlist
  </h5>
  <StatusBadge status="ITEMS" count={detail?.wishlists?.length || 0} />
</div>
  <div className="card border-0" >
<WishlistTable detail={detail} />   
  </div>
</div>

   </div>
  </>
 );
};

export default CustomerDetail;
